import { IFiveResponse, IFiveWResponse } from 'common/api/type-def';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import { CONTROL_HEADER_LABEL } from 'common/constants/TaxonomyConstants';

import { IControlHeaderData } from './type-def';

import * as api from './index';

let updateEntityTag: jest.SpyInstance;
let getObligations: jest.SpyInstance;
let getProcesses: jest.SpyInstance;
let getRisks: jest.SpyInstance;
let getControls: jest.SpyInstance;
let getPolicies: jest.SpyInstance;
let getEntityRelationMapping: jest.SpyInstance;
let getEntitiesCount: jest.SpyInstance;
let getListOfMetaData: jest.SpyInstance;

const { FREQUENCY, KEY_CONTROL, TYPE, INDUSTRY_TYPE } = CONTROL_HEADER_LABEL;
const { OK } = HTTP_STATUS_CODES;

const fiveResponse: IFiveResponse = {
	Who: ['Compliance'],
	What: [
		'Review special Measures reports issued by the US Treasury and implement necessary enhanced monitoring for customers noted to validate compliance requirements',
	],
	When: ['Upon occurrence'],
	Where: ['US Treasury'],
	Why: ['To validate compliance requirements for customer service'],
};

export const getObligationData = [
	{
		id: '4397fe9a-7700-462b-abb2-816e20911fef',
		groupName: 'dev-regulation',
		status: 'Complete',
	},
	{
		id: '2d09a4a5-5ecd-41ea-bc03-789aabe71656',
		groupName: 'dev-testing',
		status: 'Complete',
	},
];

export const getProcessesData = [
	{
		id: '77daf16f-4846-4a6d-9785-9a0a3dd4977b',
		name: 'Engage/Retain outside counsel if necessary',
		source: 'PWC',
		displayId: 'PRC_0001403',
	},
	{
		id: '71ac9d68-e3e9-4752-8174-ba4b356a61e1',
		name: 'Evaluate new product/service inputs and requirements',
		source: 'PWC',
		displayId: 'PRC_000167',
	},
];

export const getRisksData = [
	{
		id: '77daf16f-4846-4a6d-9785-9a0a3dd4977b1',
		name: 'RISK-1',
		source: 'PWC',
		displayId: 'RISK_0001403',
	},
	{
		id: '71ac9d68-e3e9-4752-8174-ba4b356a61e12',
		name: 'RISK2',
		source: 'PWC',
		displayId: 'RISK_000167',
	},
];

export const getControlsData = [
	{
		id: '77daf16f-4846-4a6d-9785-9a0a3dd4977b12',
		name: 'CONTROL-1',
		source: 'PWC',
		displayId: 'CTR_0001403',
	},
	{
		id: '71ac9d68-e3e9-4752-8174-ba4b356a61e124',
		name: 'CONTROL-2',
		source: 'PWC',
		displayId: 'CTR_000167',
	},
];

export const getPoliciesData = [
	{
		id: '77daf16f-4846-4a6d-9785-9a0a3dd4977b1273',
		name: 'policies-1',
		source: 'PWC',
		displayId: 'P_0001403',
	},
	{
		id: '71ac9d68-e3e9-4752-8174-ba4b356a61e1242389',
		name: 'policies-2',
		source: 'PWC',
		displayId: 'P_000167',
	},
];

export const mockRelationData = [
	{
		id: '6d23a2f2-d756-4e3e-95ea-8533ab0cfa65',
		parentId: '37e0f063-9439-417b-b7a2-2045030d8068',
		parentType: 'Process',
		parentName: 'Accept and validate sales orders',
		parentDisplayId: 'PRC_ETS_0006',
		childId: 'bedc12d1-1a6c-4e24-bf00-614e7590f27b',
		childType: 'Control',
		childName: 'Inventory of authority to agreements',
		childDisplayId: 'CTRL_FS_000325',
		citationGroupId: null,
		generateMode: 'MANUAL',
		reviewStatus: 'Pending Review',
		aiScore: null,
		createdBy: 'f6a2b8b6-643c-4e99-95e6-7aeaa65b2681',
		renderOrder: 0,
		swap: false,
	},
	{
		id: '6d23a2f2-d756-4e3e-95ea-8533ab0cfa652',
		parentId: '37e0f063-9439-417b-b7a2-2045030d8068',
		parentType: 'Process',
		parentName: 'Accept and validate sales orders',
		parentDisplayId: 'PRC_ETS_00061',
		childId: 'bedc12d1-1a6c-4e24-bf00-614e7590f27b',
		childType: 'Control',
		childName: 'Inventory of authority to agreements',
		childDisplayId: 'CTRL_FS_000325',
		citationGroupId: null,
		generateMode: 'MANUAL',
		reviewStatus: 'Pending Review',
		aiScore: null,
		createdBy: 'f6a2b8b6-643c-4e99-95e6-7aeaa65b2681',
		renderOrder: 0,
		swap: false,
	},
];

export const getEntityRelationMappingData = {
	page: 0,
	size: 12,
	totalPages: 2,
	totalCount: 1,
	riskCount: 2,
	processCount: 0,
	controlCount: 1,
	policyCount: 2,
	groupCount: 1,
	content: mockRelationData,
};

export const getEntitiesCountData = {
	controlCount: 13,
	groupCount: 0,
	policyCount: 1,
	processCount: 0,
	riskCount: 5,
};

export const listOfMetaData = {
	frequency: [
		{
			value: 'Monthly',
			displayValue: 'Monthly',
		},
		{
			value: 'Semi-Weekly',
			displayValue: 'Semi-Weekly',
		},
		{
			value: 'Annually',
			displayValue: 'Annually',
		},
		{
			value: 'Semi-Annually',
			displayValue: 'Semi-Annually',
		},
		{
			value: 'Daily',
			displayValue: 'Daily',
		},
		{
			value: 'Upon Occurrence',
			displayValue: 'Upon Occurrence',
		},
		{
			value: 'Ad Hoc or As Needed',
			displayValue: 'Ad Hoc or As Needed',
		},
		{
			value: 'Bi-Annually',
			displayValue: 'Bi-Annually',
		},
		{
			value: 'Quarterly',
			displayValue: 'Quarterly',
		},
		{
			value: 'Continuous',
			displayValue: 'Continuous',
		},
	],
};

export const controlHeaderData: IControlHeaderData[] = [
	{ headerLabel: FREQUENCY, labelValue: '', headerKey: 'frequency' },
	{ headerLabel: KEY_CONTROL, labelValue: '', headerKey: 'keyControl' },
	{ headerLabel: TYPE, labelValue: '', headerKey: 'type' },
	{ headerLabel: INDUSTRY_TYPE, labelValue: '', headerKey: 'industryType' },
];

export const mockControlValidationData: IFiveWResponse = {
	fiveWResponse: fiveResponse,
	controlDescription:
		'Upon occurrence, special Measures reports issued by the US Treasury are reviewed by Compliance and any necessary enhanced monitoring required is implemented for any customers noted to validate the compliance requirements as applicable for the customer service.',
	grammarScore: 0.4,
};

export const setupApiMocks = () => {
	updateEntityTag = jest.spyOn(api, 'updateEntityTag').mockResolvedValue({
		statusCode: OK,
		isError: false,
		responseBody: {
			id: '44b47d2e-8f9a-11ee-b9d1-0242ac120002',
			number: '',
			controlId: '',
			controlNumber: 'SRC-J-CTRL-1080',
			controlDescription:
				'Disclaimers or information statements provided to customers.',
			controlName: 'SRC-J-CTRL-1080',
			controlObjective: 'Customers - Disclaimers and Information Statements',
			controlOwner: 'Sean Carrol',
			frequency: '',
			metadataTag: 'tag1,tag2,tag3,tag4',
		},
	});

	getObligations = jest.spyOn(api, 'getObligations').mockResolvedValue({
		statusCode: OK,
		isError: false,
		responseBody: getObligationData,
	});

	getProcesses = jest.spyOn(api, 'getProcesses').mockResolvedValue({
		statusCode: OK,
		isError: false,
		responseBody: getProcessesData,
	});

	getRisks = jest.spyOn(api, 'getRisks').mockResolvedValue({
		statusCode: OK,
		isError: false,
		responseBody: getRisksData,
	});

	getControls = jest.spyOn(api, 'getControls').mockResolvedValue({
		statusCode: OK,
		isError: false,
		responseBody: getControlsData,
	});

	getPolicies = jest.spyOn(api, 'getPolicies').mockResolvedValue({
		statusCode: OK,
		isError: false,
		responseBody: getPoliciesData,
	});

	getEntityRelationMapping = jest
		.spyOn(api, 'getEntityRelationMapping')
		.mockResolvedValue({
			statusCode: OK,
			isError: false,
			responseBody: getEntityRelationMappingData,
		});

	getEntitiesCount = jest.spyOn(api, 'getEntitiesCount').mockResolvedValue({
		statusCode: OK,
		isError: false,
		responseBody: getEntitiesCountData,
	});
	getListOfMetaData = jest.spyOn(api, 'getListOfMetaData').mockResolvedValue({
		statusCode: OK,
		isError: false,
		responseBody: listOfMetaData,
	});
};

export const getMockedApis = () => ({
	updateEntityTag,
	getObligations,
	getProcesses,
	getRisks,
	getControls,
	getPolicies,
	getEntityRelationMapping,
	getEntitiesCount,
	getListOfMetaData,
});
